<template>
<div class="create-new-structure">

  <!-- <div class="top-bar">
    <span @click="goBack"><i class="left"></i></span>
    <span class="heading_new"> {{buttonText == 'Add Salary Structure' ?  'Create New' : 'Edit'}} Salary Structure</span>
  </div> -->
        <toast-message :message="errmsg" type="error" :isToastEnable='toast' @close ="(val) => toast = val"/>

  <div class="inner">
    <p class="custom-form-header">Select the Salary Components and map it with different criteria for creating a Salary Structure</p>
    <div class="applyfilter">
        <tl-select
        label="Applicabilty Criteria"
        labelText="name"
        name="Map To" />
        <tl-select
        label="Sub Criteria"
        labelText="name"
        name="Map To" />
        <txt label="Salary Structure Name"
        type="text" v-model="formData.name"
        name="name"/>

        <div class="row-container align-center margintop-15">
        <img src="@/assets/group-5.svg" class="Group-5" />
        <button class="text-green" @click="$router.push(`/onboarding/entity/${$route.params.entity_index}/preferences/addComponent`)">Add New Component</button>
      </div>
    </div>

    <data-table
        class="margin-t-xl"
        :columns="columnNames"
        :tableData="componentsData"
        :checkbox="true"
        :withForm="false"
        :showinheader="showinheader"
        :showedit="false"
        :search="search"
        :icons="[
                 {url:require('@/assets/garbage.png'), method: 'up'},
                 {url:require('@/assets/garbage.png'), method: 'down'},
                 {url:require('@/assets/garbage.png'), method: 'deletee'}
                 ]"
        :selectrecord="activeData"
        @delete="deleteItem"
        @editStart="editItem"
        :showhistory="false"
        :showdelete="false"
        @selected="selected"
        @deselected="deselected"
        @changeHeaderCheckbox="changeTableHeaderCheckBox"
         >
          <template v-slot:rowcontent="slotprops">
            <p v-if="slotprops.value.column.key == 'SalaryComponentType' && slotprops.value.record[slotprops.value.column.key]">
                  {{ slotprops.value.record[slotprops.value.column.key]['name']}}</p>
          </template>
        </data-table>
        <br>
      <div class="hidden">
        <txt label="FBP value"
            type="number" v-model="formData.value"
            name="name"/>
      </div>
  </div>
    <pop-up-message v-if="showSuccessMsg" :message="`Salary Structure has been successfully added.`" btnText="Back" @back="backfrompopup()"
    />
    <!-- <form action class="preferences-form">
      <div class="preferences-label">
        <div class="label-text">Name</div>
      </div>
      <div class="row">
        <div class="col-6">
          <input type="text" class="input-field" placeholder="Enter Name" name="Name" v-validate="'required'" :class="{errorr:errors.has('Name')}">
        </div>
      </div>
      <span class="errorMessage" v-show="errors.has('Name')">
        <img class="imgClass" src="@/assets/error.svg" />&nbsp;{{ errors.first('Name') }}
      </span>
      <div class="row label-top-margin">
        <div class="col-6">
          <div class="label-text">Criteria</div>
          <div class="selectdiv">
            <select class="input-field" v-on:change="showInputLocation" name="Criteria" v-validate="{ rules: { required: true } }" :class="{errorr:errors.has('Criteria')}">
              <option value="allowance">Select</option>
              <option value="location">Location</option>
            </select>
            <span class="errorMessage" v-show="errors.has('Criteria')">
              <img class="imgClass" src="@/assets/error.svg" />&nbsp;{{ errors.first('Criteria') }}
            </span>
          </div>
        </div>
        <div class="col-6" v-show="showInputBox">
          <div class="label-text">Location</div>
          <input type="text" class="input-field" placeholder="Enter Location">
        </div>
      </div>
      <div class="preferences-label">
        <div class="label-text">Description</div>
      </div>
      <div class="row">
        <div class="col-10">
          <textarea name class="textarea" cols="30" rows="5" placeholder="Salary structure description"></textarea>
        </div>
      </div>
    </form> -->
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <!-- <btn text="Previous" type="secondary" @click="goBack"/> -->
          <btn :text="buttonText" @click="save" type="primary"  />
        </btn-grp>
      </template>
  </bottom-action-container>

  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
   tabIndex: {
      type: Number,
      default: 0
    },
  name: "CreateNewSalaryStructure",
  data: function() {
    return {
      activeData : [],
      errmsg: "",
      showSuccessMsg:false,
      toast: false,
      showInputBox: false,
      showinheader: false,
      search:'',
      buttonText : 'Add Salary Structure',
      records:[],
      // columnNames: [
      //   {
      //     label: "Component",
      //     key: "name"
      //   },
      //   {
      //     label: "Type",
      //     key: "SalaryComponentType"
      //   },
      //   {
      //     label: "Tax Exempt",
      //     key: "deductionName"
      //   },
      //   {
      //     label: "Max Limit",
      //     key: "formula"
      //   }
      // ],
      columnNames: [
        {
          label: "Component",
          key: "name"
        },
        {
          label: "Type",
          key: "salary_component_type"
        },
        {
          label: "Tax Exempt",
          key: "it_section"
        },
        {
          label: "Calculation type",
          key: "calculation_type"
        },
        {
          label: "Calculation",
          key: "calculation"
        }
      ],

      mappingobject : {
        sc_id:"",
        formula:"",
        effectiveDate:""
      },
      formData: {
        name: "",
        description : "",
        le_id :"",
        mapping : [],
        rule:{}
      }
    };
  },
  computed: {
    ...mapState({
      salaryComponentsData: state =>
        state.onboard.settings.salary_component.entityWiseData,
        salaryStructureData: state =>
          state.onboard.settings.salary_structure.entityWiseData,
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
          return this.getLegalEntityId(0);
      }

    },
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    componentsData() {
      // let data = this.salaryComponentsData[this.leId];
      // for (let i = 0; i < data.length; i++) {
      //   if(data[i].part_of_ctc){
      //       data.push(data[i]);
      //   }
      // }
      //let le_id = "f2bd8f30-b270-40b9-942e-7ae917d73781";
      let data = this.salaryComponentsData[this.leId].filter(item => item.part_of_ctc == true);
      // //console.log(data);
      return data;
    }
  },
  activated() {
     // this.formData = this.$_.cloneDeep(this.blankFormData);

      if (this.$route.query.id) {


          this.editDefaultSelection();
      }

  },
  methods: {
    ...mapActions({
      act_create: "onboard/settings/salary_structure/create",
      act_update: "onboard/settings/salary_structure/update",
      act_fetchAll: "onboard/settings/salary_structure/fetchAll",

    }),


    async editDefaultSelection() {
        // this.salaryComponentsData[this.leId];
        //let le_id = "f2bd8f30-b270-40b9-942e-7ae917d73782";
       // let res = await this.act_fetchAll(le_id);
       // let obj = res.data.payload.data.find(item => item.id == this.$route.query.id);
        let obj = this.salaryStructureData[this.leId].find(item => item.id == this.$route.query.id);
        this.activeData = obj.SalaryStructureSalaryComponent;
        //this.records = this.activeData;
        this.formData.name = obj.name;
        this.formData.le_id = obj.le_id;
        this.formData.id = obj.id;
        this.formData.sc_id = obj.sc_id;
        //this.formData.mapping = this.activeData;
        //console.log(this.activeData)
        //console.log('components',this.componentsData);
        this.buttonText = 'Edit Salary Structure';
    },

    changeTableHeaderCheckBox(records){
      //console.log('changeTableHeaderCheckBox:',records);
    },

    selected(records) {
      //console.log(records);
      // let obj = {
      //   sc_id:"",
      //   formula:"",
      //   effectiveDate:""
      // }
      // obj.sc_id = record.id;
      // obj.formula = record.formula;
      // obj.effectiveDate = record.effectiveDate;
      // this.formData.mapping.push(obj);
      // this.formData. = records;
      // this.showinheader = true;
      // this.editcol='lop'
      this.records = records;
    },
    deselected(records, record) {
      //console.log("deselected records", records);
      //console.log("deselected record", record);
      this.records = records;
      // let index = this.formData.mapping.findIndex(item => item.id = record.id);
      // this.formData.mapping.splice(index,1);
      // //console.log("final form data", this.formData.mapping);
    },
    showInputLocation() {
      this.showInputBox = true
    },
    navHandler(navType) {
        if (navType == "back") {
          this.$emit("stepNum", 0);
          this.$validator.reset();
        } else if (navType == "next") {
          this.$emit("stepNum", 2);
          this.$validator.reset();
        }
      },
    goBack() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/preferences`,
        params: {
          'activeIndex': 3
        }
      });
    },
    backfrompopup() {
        this.showSuccessMsg = false;
        this.$router.push({
          path: `/onboarding/entity/${
            this.$route.params.entity_index
            }/preferences`,
          params: {
            activeIndex: 4
          }
        });
      },
    async deleteItem(rec) {
      try {
        await this.act_delete(rec);
      } catch (err) {
        //console.log(err);
      }
    },
    async editItem(rec) {
      this.$router.push({
        path: `/onboarding/entity/${
          this.$route.params.entity_index
        }/preferences/modifyComponent`,
        query: { id: rec }
      });
    },
    save() {
      // this.$router.push({
      //   path: `/onboarding/entity/${this.$route.params.entity_index}/preferences/modifyStructureDetails`
      // });
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            //console.log('save', result)
            this.performAction();
          }
        })
    },
    async performAction() {
      try{
          //this.formData.le_id = this.leId
          //this.formData.le_id = "f2bd8f30-b270-40b9-942e-7ae917d73782";
          this.formData.le_id = this.leId;
          let obj = {
              sc_id:"",
              formula:"",
              effectiveDate:""
            }
          if (!this.$route.query.id) {
            this.formData.mapping = [];
          }
          for( let i = 0; i < this.records.length; i++ ){
            obj.sc_id = this.records[i].id;
            obj.formula = this.records[i].formula ? this.records[i].formula : '';
            obj.effectiveDate = this.records[i].effectiveDate ? this.records[i].effectiveDate : '';
            this.formData.mapping.push(obj);
          }
          this.$root._data.isSaving = true;
          if (!this.$route.query.id) {
            await this.act_create({ data: this.formData });
          //  this.refresh();
          } else {
            await this.act_update({ data: this.formData });
           // this.refresh();
          }
          setTimeout(() => {
            this.showSuccessMsg = true;
            this.$root._data.isSaving = false;
          }, 500);
          this.tabIndex =1;
      } catch (error){
          this.$root._data.isSaving = false;
          //console.log(error);
          this.toast = true;
          this.errmsg = error;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.create-new-structure {
    width: 100%;
}

.top-bar {
    // height: 70px;
    padding: 20px;
    background-color: #34c0be;
    display: flex;
}

.heading_new {
    font-family: Montserrat;
    font-size: 24px;
    font-weight: bold;
    color: #ffffff;
}

.left {
    border: solid white;
    border-width: 0 2px 2px 0;
    padding: 5px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    margin-top: 9px;
    margin-right: 20px;
}
.applyfilter{
  display: flex;
  > div {
    flex-basis: 230px;
    margin-right: 30px;
  }

}
</style>
